<template>
  <router-link
    class="is-block card card--dealsmall avoid-break-inside"
    v-if="$options.filters.haspromotion(product, 'TravelDeal')"
    @click.native="trackProduct"
    :to="{
      name: 'urlaub',
      params: {
        slug: product.slug,
        contact: product.contact.slug,
      },
    }"
  >
    <div class="card-image--deal is-relative">
      <h2 class="dealsmall-headline title has-background-grey-darker has-text-white	 has-text-centered px-3 py-2 is-size-6 is-size-5-tablet is-size-5-desktop">
        <span class="is-uppercase is-inline-block">{{ $whitelabel.dealName ? $whitelabel.dealName : $t('general.travel-deal') }}</span>
      </h2>
      <div v-if="hasCountdown" class="deal-countdown has-text-weight-normal has-text-dark is-hidden-print">
        <p class="has-text-centered is-size-6-tablet deal-countdown__headline">
          {{ $whitelabel.dealCountdownTitle ? $whitelabel.dealCountdownTitle : $t('product.deal-ends') }}
        </p>
        <CountdownTimer :endTime="dealTimer" class="has-text-centered deal-countdown__timer" />
      </div>

      <picture>
        <!-- <source :srcset="`https://assets.urlaubsgutschein.kaufen/i/resize?width=550&quality=50&interlace=true&type=auto&file=${product.image}`" media="(max-width: 480px), (min-width: 769px) and (max-width: 1215px)" /> -->

        <source :srcset="`https://assets.urlaubsgutschein.kaufen/i/crop?width=420&height=250&gravity=smart&quality=50&interlace=true&type=auto&file=${product.image}`" media="(max-width: 450px)" />
        <source :srcset="`https://assets.urlaubsgutschein.kaufen/i/crop?width=750&height=420&gravity=smart&quality=50&interlace=true&type=auto&file=${product.image}`" media="(max-width: 768px)" />
        <source :srcset="`https://assets.urlaubsgutschein.kaufen/i/crop?width=450&height=350&gravity=smart&quality=50&interlace=true&type=auto&file=${product.image}`" media="(max-width: 1215px)" />
        <source :srcset="`https://assets.urlaubsgutschein.kaufen/i/crop?width=540&height=300&gravity=smart&quality=50&interlace=true&type=auto&file=${product.image}`" media="(max-width: 1407px)" />
        <!-- <source :srcset="`https://assets.urlaubsgutschein.kaufen/i/crop?width=660&height=370&gravity=smart&quality=50&interlace=true&type=auto&file=${product.image}`" media="(min-width: 1408px)" /> -->
        <source :srcset="`https://assets.urlaubsgutschein.kaufen/i/crop?width=350&height=400&gravity=smart&quality=50&interlace=true&type=auto&file=${product.image}`" media="(min-width: 1408px)" />

        <img fetchpriority="high" class="deal-img" :src="`https://assets.urlaubsgutschein.kaufen/i/crop?width=770&height=450&quality=50&gravity=smart&interlace=true&type=auto&file=${product.image}`" :alt="product.contact.name" />
      </picture>

      <!-- <Badge v-if="$options.filters.haspromotion(product, 'InsuranceIncluded')" :text="`Gutschein<br>Garantie`" :color="['rgba(253, 216, 53, 1)', 'rgba(249, 168, 37, 1)']" class="deal-badge" /> -->
      <!-- <Badge v-if="this.$whitelabel.short.toLowerCase() === 'greenstorm'" :text="`Geld-zurück<br>Garantie`" :color="['rgba(133, 176, 19, 1)', 'rgba(133, 176, 19, 1)']" class="deal-badge c-badge--greenstorm" /> -->
    </div>

    <div class="card-content">
      <ReductionDisplay ref="reductionTag" v-if="$whitelabel.showReduction" :beforePrice="product.price.list" :afterPrice="product.price.total" size="is-large" class="card-tag" />

      <p class="title card__title is-5 is-size-4-widescreen">
        <span class="is-size-7 has-text-weight-normal is-family-sans-serif">{{ product.contact.city }}, {{ product.contact.state }}</span
        ><br />
        {{ product.contact.name }}<br /><StarDisplay :stars="product.contact.category" />
      </p>
      <p class="subtitle is-6 card-subtitle mb-1">{{ product.display }}</p>

      <strong>
        <span v-for="room in product.rooms" :key="room.name">{{ room.name }}</span>
        <br />
        <span v-for="board in product.boards" :key="board.short">{{ board.longName }}</span
        >, <MinMaxDisplay :min="product.nights.min" :max="product.nights.max" />{{ $t('general.nights') }}
      </strong>

      <div class=" is-size-6 mt-1 has-text-right">
        <p>{{ $t('general.instead-of') }} {{ product.persons.max === 2 ? product.price.list / 2 : product.price.list | amount }}</p>
        <p class="has-text-weight-bold">
          {{ product.price.prefix }}
          <span class="is-size-3 card-offer__price-wrapper">
            {{ product.price.currency | currency }}
            <span class="card-offer__price is-inline-block" ref="price">{{ product.price.display | amount }}</span>
          </span>
        </p>
      </div>
    </div>
  </router-link>
</template>

<script>
//import Badge from '@/components/Badge'
import ReductionDisplay from '@/components/ReductionDisplay'
import StarDisplay from '@/components/StarDisplay'
import MinMaxDisplay from '@/components/MinMaxDisplay'
import CountdownTimer from '@/components/CountdownTimer'
import promotion from '@/common/promotion'

export default {
  name: 'Deal',
  components: {
    //Badge,
    ReductionDisplay,
    StarDisplay,
    MinMaxDisplay,
    CountdownTimer,
  },
  props: {
    product: {
      type: Object,
    },
    hasCountdown: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    dealTimer: function() {
      const cdDate = promotion.getEndDateForPromotion('TravelDeal', this.product)
      if (cdDate) {
        return cdDate - new Date()
      }
      return null
    },
  },
  methods: {
    trackProduct() {
      this.$eventDispatcher.dispatch('offer_clicked', {
        product: this.product,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
// .deal {
//   position: relative;
//   left: 50%;
//   right: 0;
//   width: 100vw;
//   transform: translateX(-50%);
//   margin-top: 3rem;
//   margin-bottom: 3rem;

//   @media screen and (max-width: 768px) {
//     .hero-body {
//       padding-top: 0;
//     }
//   }
// }

// .deal-img {
//   height: 100%;
//   width: 100%;
//   object-fit: cover;
//   max-height: 450px;
// }

// .deal-badge {
//   position: absolute;
//   bottom: 2rem;
//   left: 2.5rem;
// }

.dealsmall-headline {
  position: absolute;
  z-index: 1;
  top: 1rem;
  right: 1rem;
}

// .deal-countdown {
//   bottom: 2rem;
//   right: 0.5rem;
//   padding: 1rem 1.5rem;
//   transform-origin: right bottom;
//   transform: scale(0.7);

//   .countdown__column {
//     flex-basis: auto; //fix for ie11
//     padding-left: 0.35rem; //fix for ie11
//     padding-right: 0.35rem; //fix for ie11
//   }
// }

// .deal-countdown__timer {
//   margin-top: -1rem;
// }

// @media screen and (min-width: 480px) {
//   .deal-countdown {
//     transform: scale(1);
//   }
// }

// @media screen and (max-width: 768px) {
//   .deal-img-wrap {
//     position: relative;
//     left: 50%;
//     right: 0;
//     width: 100vw;
//     transform: translateX(-50%);
//     display: block;
//   }

//   .deal-badge {
//     left: 1rem;
//   }
// }

@media screen and (min-width: 769px) {
  .card--dealsmall {
    display: flex !important;
    flex-direction: column;
    height: 100%;

    .card-content {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
  }

  .deal-countdown {
    left: 1rem;
    right: 1rem;
    padding: 0.5rem 1rem;
    bottom: 1rem;
  }
}

@media screen and (min-width: 1408px) {
  .card--dealsmall {
    flex-direction: row;
    min-height: 25rem;

    .card-image--deal {
      flex: 1 1 55%;
    }

    .card-content {
      flex: 1 1 45%;
      padding: 1rem;
    }
  }
}
</style>
